import { Element } from '@candulabs/craft';
import { nanoid } from 'nanoid';
import React from 'react';

import BlankFormIcon from '!!react-svg-loader!./assets/blank-form.svg';
import { DropInBox, DropInLabel, DropInThumbnail } from '@candu-ai/craft/ui';
import { FORM_DEFAULT_ERROR_TEXT, FORM_STEP_DEFAULT_STYLES } from '@candu-ai/forms/constants';
import { useCraftPropsContext } from 'craft/contexts';
import { Badge } from 'craft/resolvers/Badge';
import { Form, FormStep, generateFormId } from 'craft/resolvers/Forms';

export const BlankForm = () => {
  const { contentMetadata } = useCraftPropsContext();

  return (
    <DropInBox
      id="blankForm"
      dropIn={
        <Element
          is={Form}
          name={`${contentMetadata?.name || 'Empty Form'}`}
          formId={generateFormId()}
          errorText={FORM_DEFAULT_ERROR_TEXT}
        >
          <Element is={FormStep} stepId={nanoid(6)} custom={{ css: FORM_STEP_DEFAULT_STYLES }} />
          <Element is={FormStep} stepId={nanoid(6)} type="success">
            <Element
              is={Badge}
              color="secondary"
              outline="solid"
              childrenString="Success! We’ll be in touch soon."
              custom={{
                color: 'secondary',
                outline: 'solid',
                css: {
                  borderRadius: '4px',
                  width: 'fit-content',
                },
              }}
            />
          </Element>
        </Element>
      }
    >
      <DropInThumbnail>
        <BlankFormIcon />
      </DropInThumbnail>
      <DropInLabel>Form Container</DropInLabel>
    </DropInBox>
  );
};
